export enum SpecialDiscountStatusEnum {
    None = 0,
    FullyVerified = 1,
    NotVerified = 2,
    Rejected = 3
}
